// extracted by mini-css-extract-plugin
export var box = "_l-2";
export var checkboxControl = "_l-0";
export var checkboxRow = "_l-a";
export var checked = "_l-3";
export var descriptionSpacer = "_l-c";
export var disabled = "_l-4";
export var icon = "_l-8";
export var input = "_l-1";
export var labelSpacer = "_l-b";
export var large = "_l-7";
export var medium = "_l-6";
export var small = "_l-5";
export var text = "_l-9";